import Multiple from "./Multiple/Multiple"
import Numpad from "./Numpad/Numpad"

export const KeyboardMultiple = Multiple
export const KeyboardNumpad = Numpad
